<template>
    <FestivalSection
        :lazy="true"
        :events="`${event.id}`"
    >
        <template #title>
            Komt voor in
        </template>
    </FestivalSection>

    <EventBundleSection
        :lazy="true"
        :event-bundle-query="relatedEventContentBundle"
        presentation="slider"
        section-width="bleed"
    >
        <template #title>
            Meer data
        </template>
    </EventBundleSection>

    <EventBundleSection
        :lazy="true"
        :event-bundle-query="relatedRegionHighlightBundle"
        presentation="slider"
        section-width="bleed"
    >
        <template #title>
            Onze tips in de buurt
        </template>
    </EventBundleSection>

    <EventBundleSection
        :lazy="true"
        :event-bundle-query="relatedDisciplinePurviewRegionBundle"
        presentation="slider"
        section-width="bleed"
    >
        <template #title>
            Meer zoals dit
        </template>
    </EventBundleSection>
</template>

<script setup lang="ts">
const props = defineProps<{
    event: EventDate
}>();

const relatedEventContentBundle = computed<EventBundleCustom>(() => {
    return {
        __typename: EVENT_BUNDLE_TYPE_CUSTOM,
        skipEvent: props.event.id,
        eventContent: [props.event.eventContentId],
    };
});

const relatedRegionHighlightBundle = computed<EventBundleCustom>(() => {
    return {
        __typename: EVENT_BUNDLE_TYPE_CUSTOM,
        preset: 'highlights',
        skipEvent: props.event.id,
        region: props.event.venue?.city?.region_id ? [props.event.venue?.city?.region_id] : [],
    };
});

const relatedDisciplinePurviewRegionBundle = computed<EventBundleCustom>(() => {
    return {
        __typename: EVENT_BUNDLE_TYPE_CUSTOM,
        skipEvent: props.event.id,
        discipline: props.event.disciplines.map(({ id }) => id),
        purview: props.event.purviews.map(({ id }) => id),
        region: props.event.venue?.city?.region_id ? [props.event.venue?.city?.region_id] : [],
    };
});
</script>
